import axios from 'axios';

// Use relative URL in production, works with any domain
// In development, use localhost
const API_URL = window.location.hostname === 'localhost' 
  ? 'http://localhost:8001'
  : window.location.origin;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Plans API
export const plansAPI = {
  getAll: () => api.get('/api/plans'),
  getResidential: () => api.get('/api/plans/residential'),
  getBusiness: () => api.get('/api/plans/business'),
  getFeatured: () => api.get('/api/plans/featured'),
  getById: (id) => api.get(`/api/plans/${id}`),
};

// Contacts API
export const contactsAPI = {
  create: (data) => api.post('/api/contacts', data),
  getAll: () => api.get('/api/contacts'),
  getById: (id) => api.get(`/api/contacts/${id}`),
  updateStatus: (id, status) => api.patch(`/api/contacts/${id}/status?status=${status}`),
};

// Leads API
export const leadsAPI = {
  create: (data) => api.post('/api/leads', data),
  getAll: () => api.get('/api/leads'),
  getById: (id) => api.get(`/api/leads/${id}`),
  updateStatus: (id, status) => api.patch(`/api/leads/${id}/status?status=${status}`),
};

export default api;
